import { PostEditingDetails } from "@/pages/Posts/PostEditor/PostEditor/postEditorConstants";
import { Post } from "store/posts/postConstants";
import PostCardFront from "./PostCardFront";
import PostCardInputs from "./PostCardInputs";

interface PostCardContentProps {
  isShowingInputs: boolean;
  toggleShowInputs: () => void;
  post: Post;
  postDetail: PostEditingDetails;
  handleToggleTheme: () => Promise<void>;
  isRTL: boolean;
  onClick?: () => void;
}

const PostCardContent = ({
  isShowingInputs,
  toggleShowInputs,
  post,
  postDetail,
  isRTL,
  onClick,
  handleToggleTheme,
}: PostCardContentProps) => {
  return (
    <>
      {/* Front is always rendered to determine height, hidden when flipped */}
      <div className={isShowingInputs ? "invisible" : ""}>
        <PostCardFront post={post} isRTL={isRTL} onClick={onClick} />
      </div>
      {/* Back is rendered only when flipped, positioned absolutely */}
      {isShowingInputs && (
        <PostCardInputs
          postDetail={postDetail}
          toggleShowInputs={toggleShowInputs}
          handleToggleTheme={handleToggleTheme}
        />
      )}
    </>
  );
};

export default PostCardContent;
